import React, { useEffect, useState, useRef, useContext } from "react";
import Pagination from '../../components/pagination/pagination';
import InvoiceTable from "../../components/invoiceTable";
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";
import {  Alert } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { sendAuditEvent } from "../../utils/auditTrail";
import {TenantContext} from "../../utils/tenantContext";
import {StateContext}  from "../../utils/context";

const Invoices = () => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);
  const {tenant} = useContext(TenantContext);

  const { t } = useTranslation();

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [forceUpdate, setForce] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '-', name: 'created', sort: 'created'});

  const [apiData, error, loading] = useFetch("GET", `invoices/?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}`, token, false, forceUpdate);
  const [tableData, setTableData] = useState([]);
  const lastAuditSignature = useRef("");

  const [isMoveMusicDooUser, isMoveMusicDooUserSET] = useState(false);

  useEffect(() => {
    setTableData(apiData.results);
  }, [apiData]);

  useEffect(() => {
    setTableData(apiData.results);
    setDataCount(apiData.count);
  }, [apiData]);

  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  useEffect(() => {
      if (currentUser && currentUser.contract_owner) {
        let contractOwner = currentUser.contract_owner;    
        if (contractOwner === 2) {
          isMoveMusicDooUserSET(true);
        }    
      }
  }, [currentUser]);

  useEffect(() => {
    if (loading || !apiData || !Array.isArray(tableData)) return;

    const invoiceIds = tableData.map(invoice => invoice.id);
    const signature = JSON.stringify({
      route: window.location.pathname,
      page: currrentPage,
      pageSize,
      ordering: `${ordering.order}${ordering.name}`,
      query,
      invoiceIds,
    });

    if (signature === lastAuditSignature.current) return;
    lastAuditSignature.current = signature;

    sendAuditEvent({
      token,
      eventType: 12,
      route: window.location.pathname,
      entityType: "invoice",
      entityIds: invoiceIds,
      metadata: {
        page: currrentPage,
        page_size: pageSize,
        query,
      },
    });
  }, [apiData, tableData, loading, token, currrentPage, pageSize, ordering.order, ordering.name, query]);

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  return (
    <>
      {      
        loading ? (
          <TableHelper loading />
        ) : error ? (
          <TableHelper error />
        ) : (
        <div>
          { (!currentUser.can_add_invoices) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.cantAddInvoices" >
              Unfortunately, you can not currently add invoices. Either your tax or payment
              account data is not fully completed. In order to unlock this feature, please 
              contact our support team.
              </Trans>
            </Alert>
          }
          { (currentUser.can_add_invoices && !currentUser.invoicing_available) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.invoicingNotAvailable">
                Generate invoices from the 3rd to the 22nd of each month. Please note that invoice
                generation is not possible from the 23rd until the 2nd of the next month, as automated
                payments are processed during this period. Thank you for your understanding. 
              </Trans>
            </Alert>
          }
          { (currentUser.can_add_invoices && currentUser.invoicing_available && currentUser.invoices_generating>0) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.generatingInvoices" >
                You can not add invoices at the moment as you have invoices which are currently generating. Please check back later.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.invoices && currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.subscriptionUpgrade" >
                Your current subscription plan does not support this feature. Please <a href="/subscription/upgrade/">upgrade</a> your subscription plan to avail this feature.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.invoices && !currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.subscriptionExpired" >
                Your subscription has expired. Please <a href="/subscription/">resume</a> your subscription to avail this feature.
              </Trans>
            </Alert>
          }
          { 
            (!currentUser.invoices && !currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="invoices.view.message.noAccess" >
                You don't have access to this module, please contact the support team for further information.
              </Trans>
            </Alert>
          }
          { (currentUser.invoices) &&
            <>
              <ViewLayout title={t("invoices.view.table.title")}>
                <InvoiceTable
                  {...tableProps}
                  searchQuery={{setQuery, query, ordering, setOrdering}}
                  isMoveMusicDooUser={isMoveMusicDooUser}
                  auditData={{ token, route: "/invoices" }}
                />
              </ViewLayout>
              <Pagination pagination={paginationProps}/>
            </>
          }
        </div>
      )}
    </>
  );
};

export default Invoices;
